import AsyncStatus from 'mini-common-schema/lib/schema/AsyncStatus';
import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import SearchTableQuery from 'mini-mail-list-store/lib/store/schema/SearchTableQuery';
import { action, mutatorAction } from 'satcheljs';
import { getMailSearchStore } from '../store/Store';
import { SearchSourcePreference } from 'mini-search-common/lib/schema/SearchSourcePreference';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

/**
 * Mutator Action to set given folderId in MailQueryParams of search store
 */
export const setLastSelectedMailFolderId = mutatorAction(
    'setLastSelectedMailFolderId',
    (folderId: string) => {
        getMailSearchStore().lastSelectedMailFolderId = folderId;
    }
);

/**
 * Action to trigger mail search execution
 */
export const executeMailSearch = action('executeMailSearch');

/**
 * Mutator action to increment the searchNumber in the search store
 */
export const incrementSearchNumber = mutatorAction('incrementSearchNumber', () => {
    getMailSearchStore().searchNumber += 1;
});

/**
 * Mutator action to update table values on search complete, in list-view-store
 */
export const updateCurrentTableValuesForSearchComplete = mutatorAction(
    'updateCurrentTableValuesForSearchComplete',
    (isError: boolean) => {
        const currentSelectedTableView = getCurrentSelectedTableView();
        if (currentSelectedTableView) {
            currentSelectedTableView.isInitialLoadComplete = true;
            currentSelectedTableView.hasErrorLoadingTable = isError;
            currentSelectedTableView[isError ? 'totalRowsInView' : 'currentLoadedIndex'] =
                currentSelectedTableView.itemIds.length;
        }
    }
);

/**
 * Mutator action to increment rowOffset value in search TableView.tableQuery by a given value
 * @param incrementValue : number by which the rowOffset has to be increased
 */
export const incrementRowOffset = mutatorAction('incrementRowOffset', (incrementValue: number) => {
    const currentSelectedTableView = getCurrentSelectedTableView();
    if (currentSelectedTableView?.tableQuery?.type === TableQueryType.Search) {
        (currentSelectedTableView.tableQuery as SearchTableQuery).rowOffset += incrementValue;
    }
});

/**
 * Mutator action to set the search source in mailQueryParams in SearchStore
 * @param searchSource
 */
export const setSearchSource = mutatorAction(
    'setSearchSource',
    (searchSource: SearchSourcePreference) => {
        getMailSearchStore().searchSource = searchSource;
    }
);

/**
 * This mutator action sets the currentFolderScopeId in search store with the provided folderId
 */
export const setCurrentFolderScopeId = mutatorAction(
    'setCurrentFolderScopeId',
    (folderId: string) => {
        getMailSearchStore().currentFolderScopeId = folderId;
    }
);

/**
 * Mutator action which sets the Mail search Result referenceItemId returned by 3S.
 */
export const addSearchResultsItemId = mutatorAction(
    'addSearchResultsItemId',
    (itemId: string, referenceId: string, traceId: string) => {
        getMailSearchStore().searchResultsItemIdToReferenceIdMap.set(itemId, {
            referenceId,
            traceId,
        });
    }
);

/** Mutator action which sets the Mail search results asyncStatus based on network call */
export const setAsyncStatus = mutatorAction('setAsyncStatus', (status: AsyncStatus) => {
    getMailSearchStore().asyncStatus = status;
});

/** Mutator action which sets the current mail results logical id */
export const setMailResultsLogicalId = mutatorAction(
    'setMailResultsLogicalId',
    (logicalId: string) => {
        getMailSearchStore().currentLogicalId = logicalId;
    }
);
